<template>
  <div>
    <!-- 导入弹窗 -->
    <el-dialog :title="importDialogTitle"
      :visible.sync="show"
      :before-close="handleBeforeClose"
    >
      <el-form
        ref="importFormRef"
        :model="importModel"
        :rules="importRules"
        label-width="150px"
        label-position="right"
      >
        <div class="import-images-notice" v-if="importType === IMPORT_TYPE.IMG">
          <p v-if="customerType === CUSTOMER_TYPE.person">1、请将证件照片以手机号为文件名，放在一个文件夹中，将文件夹压缩为zip文件后上传，压缩包最大支持200M。</p>
          <p v-else>1、将要导入的照片名称 更改为对应：「企业客户的企业名称」, 放在一个文件夹中，将文件夹压缩为zip文件后上传，压缩包最大支持200M。</p>
          <p>2、点击【X】/【取消】按钮，将取消文件上传。</p>
        </div>
        <el-form-item label="证照类型：" prop="type" v-if="importType === IMPORT_TYPE.IMG">
          <el-select
            v-if="customerType === CUSTOMER_TYPE.person"
            v-model="importModel.type"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in CUSTOMER_CONFIG[customerType].importImgTypes"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
          <span v-else>营业执照</span>
        </el-form-item>
        <el-form-item :label="uploadFileLabel" prop="fileList">
          <el-upload
            style="width: 200px;"
            ref="importUploadRef"
            action="/admin/v1/vehicle/fs/standard/upload"
            :headers="getHeaders()"
            :accept="uploadFileLimit"
            :limit="1"
            :data="uploadParams"
            :file-list="importModel.fileList"
            :on-remove="handleFileRemove"
            :before-upload="handleBeforeUpload"
            :on-success="handleOnSuccess"
            :on-error="handleOnError"
          >
            <el-button
              type="minor"
              :loading="importModel.loading"
              :disabled="importModel.fileList.length > 0"
            >
              点击上传
            </el-button>
          </el-upload>
          <a v-if="importType === IMPORT_TYPE.CTM"
            v-bind:href="CUSTOMER_CONFIG[customerType].importCtmTpl"
          >下载导入模板</a>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button type="minor" @click="clickCancel">取消</el-button>
        <el-button
          @click="clickSubmit"
          :loading="importModel.loading"
          type="primary"
          :disabled="submitDisabled"
        >提交</el-button>
      </template>
    </el-dialog>
    <!-- 提交成功弹窗 -->
    <el-dialog
      :visible.sync="submitSuccessDialogVisible"
      :title="importDialogTitle"
    >
      <div>
        文件解析中，预计需要10分钟进行系统处理，请稍后在
        <span class="link" @click="gotoTaskList">
          日志-导入记录-{{IMPORT_CONFIG[importType].title}}导入历史
        </span>
        中查看导入结果。
      </div>
      <template #footer>
        <el-button type="minor" @click="submitSuccessDialogVisible = false">取消</el-button>
        <el-button
          @click="gotoTaskList"
          type="primary"
        >查看录入记录</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { uploadTaskCreate } from '@/api/domain/others'
import { CUSTOMER_TYPE, CUSTOMER_CONFIG, IMPORT_TYPE, IMPORT_CONFIG } from './config'
import { getHead } from '@/utils'

export default {
  name: 'BatchImport',
  props: {
    // 导入类型 IMG | CTM
    importType: {
      type: String,
      default: IMPORT_TYPE.IMG,
    },
    // 导入弹窗展示开关
    importVisible: {
      type: Boolean,
      default: false,
    },
    // 客户类型 person | company
    customerType: {
      type: String,
      default: CUSTOMER_TYPE.person,
    },
  },
  data() {
    return {
      CUSTOMER_TYPE,
      CUSTOMER_CONFIG,
      IMPORT_TYPE,
      IMPORT_CONFIG,
      // 导入证照数据对象
      importModel: {
        type: null,
        loading: false,
        url: '', // 文件url
        fileList: [],
      },
      show: this.importVisible,
      // 提交成功弹窗展示开关
      submitSuccessDialogVisible: false,
    }
  },
  watch: {
    importVisible(val) {
      this.show = val
      if (val) {
        // 如果是企业客户导入证照，将证照类型置为经营执照
        if (this.importType === IMPORT_TYPE.IMG && this.customerType === CUSTOMER_TYPE.company) {
          this.importModel.type = CUSTOMER_CONFIG[CUSTOMER_TYPE.company].importImgTypes[0].value
        }
        this.$nextTick(() => {
          this.$refs.importFormRef.clearValidate()
        })
      }
    },
  },
  computed: {
    // 弹窗标题
    importDialogTitle() {
      return `${CUSTOMER_CONFIG[this.customerType].importLabel}${IMPORT_CONFIG[this.importType].title}导入`
    },
    // 表单校验规则
    importRules() {
      return IMPORT_CONFIG[this.importType].rules
    },
    // 上传文件标签
    uploadFileLabel() {
      return IMPORT_CONFIG[this.importType].label
    },
    // 上传参数
    uploadParams() {
      let code = 'assert_driver_pic_package'
      if (this.importType === IMPORT_TYPE.CTM) {
        code = this.customerType === CUSTOMER_TYPE.person ? 'assert_person_file' : 'assert_company_file'
      }
      return {
        group: 'assert',
        code,
      }
    },
    // 上传文件类型限制
    uploadFileLimit() {
      return this.importType === IMPORT_TYPE.IMG ? '.zip' : '.xls,.xlsx'
    },
    // 提交按钮禁用状态
    submitDisabled() {
      // 证照图片导入需要校验证照类型字段
      if (this.importType === IMPORT_TYPE.IMG && this.customerType === CUSTOMER_TYPE.person) {
        return this.importModel.fileList.length <= 0 || !this.importModel.type
      }
      return this.importModel.fileList.length <= 0
    },
  },
  methods: {
    getHeaders() {
      return getHead(this.$store)
    },
    handleBeforeUpload(file) {
      if (file.size > 1024 * 1024 * 200) {
        this.$message.error('文件大小超过200M，请分批导入')
        return false
      }
      if (file.type !== 'application/zip' && file.type !== 'application/x-zip-compressed') {
        this.$message.error('文件格式错误，请上传zip格式文件')
        return false
      }
      this.importModel.loading = true
    },
    // 上传证照成功
    handleOnSuccess(res, file) {
      const { code, data: url } = res
      if (code === 1) {
        this.importModel.fileList.push(file)
        this.importModel.url = url
      }
      this.importModel.loading = false
    },
    // 删除上传文件
    handleFileRemove() {
      this.importModel.url = ''
      this.importModel.loading = false
      this.importModel.fileList = []
    },
    handleOnError(e) {
      this.importModel.loading = false
      this.$message.error('导入失败', e)
    },
    // 提交导入表单
    clickSubmit() {
      this.$refs.importFormRef.validate((valid) => {
        if (!valid) return
        this.importModel.loading = true
        const params = {
          fileAddress: this.importModel.url,
          fileName: this.importModel.fileList[0]?.name,
        }
        // 证照图片上传需要指定上传的证照类型
        if (this.importType === IMPORT_TYPE.IMG) {
          params.uploadType = this.importModel.type
        }
        // 创建导入任务
        uploadTaskCreate(params).then((res) => {
          if (res?.code === 1 && res?.data) {
            this.$emit('update:importVisible', false)
            this.$refs.importFormRef.resetFields()
            this.submitSuccessDialogVisible = true
          }
        }).finally(() => {
          this.importModel.loading = false
        })
      })
    },
    // 点击右上角关闭icon
    handleBeforeClose(done) {
      this.$refs.importUploadRef.abort()
      this.$refs.importFormRef.resetFields()
      this.importModel.loading = false
      this.importModel = {
        type: null,
        loading: false,
        url: '', // 文件url
        fileList: [],
      }
      this.$emit('update:importVisible', false)
      done()
    },
    // 点击取消
    clickCancel() {
      this.$refs.importUploadRef.abort()
      this.$refs.importFormRef.resetFields()
      this.importModel = {
        type: null,
        loading: false,
        url: '', // 文件url
        fileList: [],
      }
      this.$emit('update:importVisible', false)
      this.importModel.loading = false
    },
    // 跳转导入任务列表
    gotoTaskList() {
      this.submitSuccessDialogVisible = false
      this.$router.push({
        path: IMPORT_CONFIG[this.importType].taskLink,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.import-images-notice {
  padding: 4px 8px;
  color: #276BEC;
  border-color: #D0DEF7;
  background-color: #EFF3FF;
  font-size: 12px;
  margin-bottom: 16px;
}
.link {
  margin: 0 2px;
  color: #276BEC;
  cursor: pointer;
}
</style>
